import { FileText } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'

type ReuniaoNextStepModalProps = {
  open: boolean
  confirming: boolean
  onClose: () => void
  onGoToProposta: () => void
  onStayInRealizada: () => void
}

export function ReuniaoNextStepModal({
  open,
  confirming,
  onClose,
  onGoToProposta,
  onStayInRealizada,
}: ReuniaoNextStepModalProps) {
  return (
    <Modal
      open={open}
      onClose={() => !confirming && onClose()}
      title="Reunião confirmada — próximo passo"
      description="A reunião será marcada como realizada e a qualificação BANT será salva. Como deseja continuar?"
      size="sm"
      footer={
        <div className="flex flex-col gap-2 w-full">
          <Button
            variant="primary"
            size="sm"
            icon={<FileText size={13} />}
            loading={confirming}
            onClick={onGoToProposta}
            className="w-full"
          >
            Ir para Proposta em elaboração
          </Button>
          <Button
            variant="secondary"
            size="sm"
            loading={confirming}
            onClick={onStayInRealizada}
            className="w-full"
          >
            Ficar em Reunião Realizada
          </Button>
          <Button variant="ghost" size="sm" disabled={confirming} onClick={onClose} className="w-full">
            Cancelar
          </Button>
        </div>
      }
    >
      <p className="text-sm text-text-secondary">
        Se escolher proposta, o deal pula a etapa intermediária e abre direto a elaboração da proposta
        com o BANT já registrado.
      </p>
    </Modal>
  )
}
